import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      /*
       * Fade on scroll
       */
      gsap.registerPlugin( ScrollTrigger );
      $( '.js-fade:not(.js-ignore), .js-fade-group' ).each( function() {
        gsap.registerPlugin( ScrollTrigger );
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 90%',
            scrub: 0.15,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'js-animated' ),
          },
        } );
      } );

      /*
       * Reveal on scroll
       */
      gsap.registerPlugin( ScrollTrigger );
      $( '.js-reveal:not(.js-ignore)' ).each( function() {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 90%',
            scrub: false,
          },
        } );
        tl.to( this, {clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)', duration: 1.5, ease: 'power4.inOut'} );
      } );

      // button hover effect
      let element; let circle; let d; let x; let y;
      $( document ).on( 'mouseover', '.btn, button[type="submit"], button.gform_next_button', function( e ) {
        element = $( this );

        if ( element.find( '.btn-circle' ).length == 0 ) {
          element.prepend( '<span class=\'btn-circle\'></span>' );
        }

        circle = element.find( '.btn-circle' );
        circle.removeClass( 'animate' );

        if ( !circle.height() && !circle.width() ) {
          d = Math.max( element.outerWidth(), element.outerHeight() );
          circle.css( {height: d, width: d} );
        }

        x = e.pageX - element.offset().left - circle.width()/2;
        y = e.pageY - element.offset().top - circle.height()/2;

        circle.css( {top: y+'px', left: x+'px'} ).addClass( 'animate' );
      } ).on( 'mouseout', '.btn, button[type="submit"], button.gform_next_button', function( e ) {
        element = $( this );

        circle = element.find( '.btn-circle' );

        if ( !circle.height() && !circle.width() ) {
          d = Math.max( element.outerWidth(), element.outerHeight() );
          circle.css( {height: d, width: d} );
        }

        x = e.pageX - element.offset().left - circle.width()/2;
        y = e.pageY - element.offset().top - circle.height()/2;

        circle.css( {top: y+'px', left: x+'px'} ).removeClass( 'animate' );
      } );

      $( '[data-tilt]' ).tilt( {
        maxTilt: 50,
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
